import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import RevstackDatePicker from "@components/drop-downs/revstack-date-picker/RevstackDatePicker";
import RevstackChannelsSelect from "@components/drop-downs/RevstackChannelsSelect";
import ClientsSelector from "@components/drop-downs/ClientsSelector";
import BetaBadge from "@components/widgets/BetaBadge";
import { ITitle } from "@ts/common-types";
import { showBetaTag } from "@/ts/revstack/ui-utils";

const RevstackLayoutHeader = () => {
    const title = useSelector((state: ITitle) => state.title.value);

    return (
        <Row
            className="revstack-header w-100 border-bottom border-1 bg-white px-5"
            align="middle"
            style={{ minHeight: 50 }}
        >
            <Col flex="3" className="d-flex justify-content-start">
                <h5 className="mb-md-0 me-3" data-testid="title">
                    {title}
                </h5>
                {
                    showBetaTag(title) && (
                        <BetaBadge letterSpacing="0.6px" />
                    )
                }
            </Col>
            <Col
                flex="3"
                className="d-flex align-items-center justify-content-end w-100 gap-2"
            >
                <RevstackDatePicker />
                <RevstackChannelsSelect />
                <ClientsSelector
                    isDashboardModule={true}
                    showDefaultClientButton={false}
                    styles={{
                        width: 210,
                    }}
                />
            </Col>
        </Row>
    );
};

export default RevstackLayoutHeader;
